import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ResourceLibraryPage from './ResourceLibraryPage'

export default function ResourceLibraryWrapper(props) {
  const queryClient = React.useMemo(() => new QueryClient(), [])
  return (
    <QueryClientProvider client={queryClient}>
      <ResourceLibraryPage {...props} />
    </QueryClientProvider>
  )
}